import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { FaEllipsisVertical } from "react-icons/fa6";

import { ListOfButtonShape } from "@/constants/profile";

import styles from "@profileStyles/Modal.module.scss";

export default function Modal({
  popup,
  show,
  onClose,
  size,
  noBorder,
  title,
  subTitle,
  children,
  buttonShape,
  onShare
}) {
  const [open, setOpen] = useState(false);
  const childRef = useRef(null);

  useEffect(() => {
    if (show) {
      document?.body.classList.add("no-scroll");
    } else {
      document?.body.classList.remove("no-scroll");
    }

    return () => document?.body.classList.remove("no-scroll");
  }, [show]);

  useEffect(() => {
    if (childRef.current) {
      setTimeout(() => {
        setOpen(show);
      }, 200)
    }
  }, [children, show]);

  return (
    <div
      className={`${styles.modalOverlay} ${styles[open ? "visible" : "hidden"]}`}
      onClick={onClose}
    >
      <div
        className={`${styles.modalContent} ${styles[size]} ${noBorder && styles.modalContentNoBorder}`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        <div
          className={styles.modalHeader}
        >
          {!!onShare && (
            <div
              className={styles.shareButton}
              onClick={onShare}
            >
              <FaEllipsisVertical />
            </div>
          )}
          {title && (
            <h2 className={styles.modalTitle}>{title}</h2>
          )}
          {subTitle && (
            <h4 className={styles.modalSubTitle}>{subTitle}</h4>
          )}
        </div>
        <div
          className={styles.modalBody}
          ref={childRef}
        >
          {children}
        </div>
        {!popup && (
          <div
            className={styles.modalFooter}
          >
            <button
              style={(ListOfButtonShape[buttonShape]?.["style"] || {})}
              title="Close Modal"
              name="Close Modal"
              className="btn-outline"
              onClick={onClose}
            >
              <FormattedMessage id="domain-page-event-dialog-close-button" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
